import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["type", "name", "id", "placeholder", "label", "className", "dataHook", "onValidate", "onBlur"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import Input from '@segment/matcha/components/Input';
import emailRegex from '@segment/utils/regexes/email';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var companyEmailMessages = {
  required: "Please provide your company email address.",
  invalid: "Please enter a valid email address.",
  sharedEmail: "Please provide an individual corporate email address.",
  forbiddenEmail: "Please enter a valid business email address."
};

var getUrlParameter = function getUrlParameter(name) {
  if (false) return;
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(window.location.search);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}; // Email decoding utility, stolen from https://github.com/segmentio/publix/blob/5c12bad05990ea314567bcf5083c0548184bf1a7/src/apps/v2/lib/Util.ts#L1.
// Note that this utility does not decode Unicode properly.


var decodeEmail = function decodeEmail(hash) {
  try {
    return atob(decodeURIComponent(hash));
  } catch (e) {
    console.error("Failed to decode \"" + hash + "\":", e);
  }

  return hash;
};

/**
 * Email input
 */
export var CompanyEmailField = function CompanyEmailField(_ref) {
  var _errors$name;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "email" : _ref$type,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? "email" : _ref$name,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? "email" : _ref$id,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Your work email" : _ref$placeholder,
      label = _ref.label,
      className = _ref.className,
      dataHook = _ref.dataHook,
      onValidate = _ref.onValidate,
      _onBlur = _ref.onBlur,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useFormContext = useFormContext(),
      register = _useFormContext.register,
      trigger = _useFormContext.trigger,
      setError = _useFormContext.setError,
      errors = _useFormContext.formState.errors; // Pre-populate field from encoded param if applicable


  var decodedEmail = "";
  var emailParam = getUrlParameter("email");

  if (emailParam) {
    decodedEmail = decodeEmail(emailParam);
  }

  var _useState = useState(emailRegex.test(decodedEmail)),
      valid = _useState[0],
      setValid = _useState[1];

  var _useState2 = useState(false),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var handleValidation = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
      var emailValue, validatorResponse, isResponseValid, validator;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              emailValue = value.trim();
              validatorResponse = {
                valid: true,
                message: ""
              };
              isResponseValid = emailRegex.test(emailValue);

              if (!(typeof onValidate === "function")) {
                _context.next = 12;
                break;
              }

              setIsLoading(true);
              _context.next = 7;
              return onValidate(emailValue);

            case 7:
              validator = _context.sent;
              validatorResponse.valid = validator.valid;
              validatorResponse.message = validator.message;
              isResponseValid = validatorResponse.valid;
              setIsLoading(false);

            case 12:
              setValid(isResponseValid);

              if (!isResponseValid) {
                setError(name, {
                  type: "validate",
                  message: validatorResponse.message
                });
              }

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [onValidate]);
  return _jsx(Input, _objectSpread(_objectSpread({
    className: className,
    id: id,
    placeholder: placeholder,
    label: label,
    type: type,
    "aria-label": placeholder,
    error: Boolean(errors[name]),
    showValidState: valid && Boolean(!errors[name]),
    errorText: (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message,
    expanded: true,
    value: decodedEmail,
    "data-hook": dataHook,
    onAutoFill: function onAutoFill(value) {
      handleValidation(value);
      trigger(name);
    },
    isLoading: isLoading
  }, register(name, {
    required: companyEmailMessages.required,
    pattern: {
      value: emailRegex,
      message: companyEmailMessages.invalid
    },
    onBlur: function onBlur(e) {
      trigger(name);
      handleValidation(e.target.value);
      if (_onBlur && !valid && Object.hasOwn(errors, name)) _onBlur(errors);
    }
  })), rest));
};